export default {
  mounted() {
    window.addEventListener('beforeunload', this.clearLocalStorage);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.clearLocalStorage);
  },
  methods: {
    clearLocalStorage() {
      localStorage.removeItem('selectedTags');
    }
  }
};
